import {IceClientConfig} from "@neolab/ice-client";
import {Ganymede} from '@slices/Ganymede/ClientManager';
import '@slices/Ganymede/UserManager';
import {Permissions} from '@slices/Permissions/Permissions';
import '@slices/Permissions/PermissionManager';

const iceConfig = require<{[key: string]: string}>('../ice.config.yaml');

const config: IceClientConfig = {
  propertyPrefix: 'App',
  iceConfig,
  proxies: {
    ClientManager: {
      property: 'App.ClientManager',
      type: Ganymede.ClientManagerPrx,
      authenticate: true,
    },

    UserManager: {
      property: 'App.UserManager',
      type: Ganymede.UserManagerPrx,
      authenticate: true,
    },

    PermissionManager: {
      property: 'App.PermissionManager',
      type: Permissions.PermissionManagerPrx,
      authenticate: true,
    },

    Permissions: {
      property: 'App.Permissions',
      type: Permissions.PermissionsServicePrx,
      authenticate: true,
    },
  },
};

export default config;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/iceClientConfig.ts